<app-auth-layout>
  <div>
    <h1>{{ loginContent()?.welcomeLabel }}</h1>
    <span class="subtitle">{{ loginContent()?.descriptionLabel }}</span>
  </div>
  <div>
    <form [formGroup]="formLogin" (ngSubmit)="onSubmit()">
      <div class="form-inner">
        <div class="input-container">
          <input
            type="email"
            class="form-control"
            formControlName="email"
            [placeholder]="loginContent()?.emailLabel"
            [ngClass]="{
              'error-required':
                submitted && formLogin.get('email')?.hasError('required'),
              'error-format':
                submitted &&
                !formLogin.get('email')?.hasError('required') &&
                formLogin.get('email')?.invalid
            }"
          />
        </div>
        <div class="input-container">
          <input
            type="password"
            class="form-control"
            formControlName="password"
            required
            [placeholder]="loginContent()?.passwordLabel"
            [ngClass]="{
              'error-required':
                submitted && formLogin.get('password')?.hasError('required'),
              'error-format':
                submitted &&
                !formLogin.get('email')?.hasError('required') &&
                formLogin.get('email')?.invalid
            }"
          />
        </div>

        @if(showEmptyFieldsError){
          <div class="alert container-error">
            <img [src]="errorIcon()?.path ?? ''" [alt]="errorIcon()?.alt ?? ''" class="icon"/>
            {{ loginContent()?.instructionsLabel }}
          </div>
        @if(!showEmptyFieldsError && (submitted && formLogin.invalid)){
          <div class="alert container-error">
            <img [src]="errorIcon()?.path ?? ''" [alt]="errorIcon()?.alt ?? ''" class="icon"/>
            {{ loginContent()?.emailOrPasswordError }}
          </div>
        }
        } @if(loginError()){
          <div class="alert container-error">
            <img [src]="errorIcon()?.path ?? ''" [alt]="errorIcon()?.alt ?? ''" class="icon"/>
            {{ loginErrorMessage() ?? loginContent()?.errorToLogin }}
          </div>
        }

        <button type="submit" class="btn-submit">{{ loginContent()?.loginButton }}</button>
        <!-- <span class="register-text">¿No tienes cuenta?<a [routerLink]="'/registrar'" class="register-link">Registrarme</a></span> -->
      </div>
    </form>
  </div>
  <div class="container-checkbox">
    <!-- <label> <input type="checkbox" />Recordarme</label> -->
    <span>
      <a [routerLink]="'/reset-password'">{{ loginContent()?.forgotPasswordLabel }}</a>
    </span>
  </div>
</app-auth-layout>
